import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Apple = (props: SvgProps) => (
  <Svg viewBox='0 0 17 19' {...props}>
    <Path
      d='M13.4 18.235c-1.03 1-2.165.844-3.247.373-1.151-.482-2.203-.512-3.418 0-1.513.654-2.316.463-3.227-.373C-1.638 12.93-.878 4.849 4.969 4.545c1.419.076 2.412.785 3.247.844 1.242-.253 2.43-.978 3.76-.883 1.596.13 2.79.761 3.587 1.896-3.284 1.978-2.506 6.313.511 7.53-.604 1.588-1.378 3.156-2.677 4.316l.002-.013ZM8.101 4.487C7.948 2.13 9.856.19 12.052 0c.301 2.72-2.469 4.754-3.95 4.487Z'
      fill='currentColor'
    />
  </Svg>
)
